import React, { Component } from "react";
import { 
    Row, Col,
    Card, CardHeader, CardBody
} from "reactstrap";

import { NotificationManager } from "react-notifications";
import Registry from "../../../Utils/Registry";

import TYItem from "../../TYItem";
import TYSelect from "../../TYSelect";

import RecVehicleModal from "./vehicleModal";
import OperationsRecurrentDetailsVehicle from "./vehicle";
import OperationsRecurrentDetailsContact from "./contact";

const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];


export default class OperationsRecurrentDetails extends Component{
    constructor(props){
        super(props);

        this.state = {
            id: props.recId,
            loadingPaymentMethods: false,
            loading: false,
            data: {},
            contacts: [],
            paymentMethods: [],
            updatingPaymentMethod: false,
            addingContacts: false,
            availableContacts: [],
            vehicleModalShown: false,
            updateVehicleData: null
        }

        this.api = Registry.registered("api");
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = () => {
        if(this.state.id !== null){
            this.setState({data: {}, loading: true});
            this.api.get(`/recurrent/${this.state.id}`)
                .then(r => {
                    this.setState({
                        data: r, 
                        loading: false
                    }, () => {
                        this.getPaymentMethods();
                        this.loadContacts();
                        this.loadBusinessContacts();
                    });
                })
                .catch(_ => {
                    NotificationManager.error("Impossible de charger les information de la recurrence");
                    this.setState({loading: false});
                })
        }
    };

    loadContacts = () => {
        this.setState({contacts: []});
        this.api.get("/recurrent/" + this.state.id + "/contacts")
            .then(r => {
                this.setState({contacts: r});
            });
    }

    loadBusinessContacts = () => {
        this.setState({availableContacts: []});
        this.api.get(`/business/${this.state.data.business_id}/contacts`)
            .then(r => {
                this.setState({availableContacts: r});
            })
    }

    addContact = (id, i) => {
        this.api.post(`/recurrent/${this.state.id}/contact/attach`, {contact_id: id})
            .then(_ => {
                this.loadContacts();
                NotificationManager.success("Contact ajouté à la recurrence");
                let tmp = this.state.availableContacts.slice();
                tmp.splice(i, 1);
                this.setState({availableContacts: tmp});
            })
            .catch(_ => {
                NotificationManager.error("Impossible d'ajouter le contact sur la recurrence");
            });
    }

    getPaymentMethods = () => {
        if(!this.state.id)
            return;
        
        this.setState({ paymentMethods: [], loadingPaymentMethods: true });
        this.api.get("/business/paymentMethods")
            .then(results => {
				let paymentMethods = [{id: "bill", type: 0, label: "Virement", owner: this.id}];
                
                if (results && results.hasOwnProperty("data")){
					for (let pm of results.data){
						let pmLabel = "**** " + (pm.object === "card" ? pm.last4 : pm.sepa_debit.last4);
						if (pm.metadata.name)
							pmLabel = pm.metadata.name + " - " + pmLabel;
                        
                        paymentMethods.push({
                            id: pm.id,
                            label: pmLabel,
                            type: (pm.object === "card" ? 1 : 2),
                            owner: this.state.id
						});
					}
                }
                
                this.setState({ paymentMethods, loadingPaymentMethods: false });
            })
            .catch(_ => { this.setState({loadingPaymentMethods: false})});
    }

    onPaymentMethodChange = item => {
        this.setState({ loading: true, updatingPaymentMethod: false });
        this.api.put("/recurrent/" + this.state.id, { payment_id: item.id })
            .then(_ => {
                NotificationManager.success("Moyen de payment mis à jour");
                this.loadData();
            })
            .catch(err => {
                this.setState({loading: false});
                let errMsg = "Impossible de mettre le moyen de paiement à jour";
                if (err.hasOwnProperty("subcode")) {
                    switch(err.subcode) {
                        case "PUTRecurrentInvalidpaymentId":
                            errMsg = "Veuillez renseigner un moyen de paiement";
                            break;
                        default:
                            errMsg = "Impossible de mettre le moyen de paiement à jour";
                            break;
                    }
                }
                NotificationManager.error(errMsg);
            });
    }

    onUpdateVehicleRequest = data => {
        this.setState({vehicleModalShown: true, updateVehicleData: data});
    }

    render(){
        const {
            data,
            contacts,
            loading,
            paymentMethods,
            updatingPaymentMethod,
            loadingPaymentMethods,
            addingContacts,
            availableContacts,
            vehicleModalShown,
            updateVehicleData,
            ...state
        } = this.state;

        if(!loading && !data.id)
            return null;

        let paymentMethod = null;
        let paymentMethodsForUpdate = [];
        if (paymentMethods.length > 0) {
            for (let i = 0; i < paymentMethods.length; i++) {
                if (paymentMethods[i].id === data.payment_id){
                    let icon = "icon icon-file";
                    if(paymentMethods[i].type === 1) // Card type
                        icon = "icon icon-credit-card";
                    else if(paymentMethods[i].type === 2) // SEPA transfert type
                        icon = "icon icon-sepa";
                    paymentMethod = {
                        label: paymentMethods[i].label,
                        icon: icon
                    };
                }
                if(paymentMethods[i].id !== "bill")
                    paymentMethodsForUpdate.push(paymentMethods[i]);
            }
        }
        
        let activeContactIds = [];
        if(addingContacts){
            for(let c of contacts)
                activeContactIds.push(c.id);
        }

        let activeVehicles = [];
        if(data.vehicles){
            for(let v of data.vehicles)
                activeVehicles.push(v.plate);
        }

        return <Row>
            <Col xs="12" sm="12" lg="6">

                {
                    loading ?
                        <div className="center">
                            <i className="icon icon-loading animated spin infinite f-20"> </i>
                        </div>
                        :
                        <Card>

                            <CardHeader className="ty-order-header relative blue_dark">
                                <div className="pad-l-15 display-inline-block">
                                    Recurrence n&deg; { data.id }
                                </div>
                            </CardHeader>

                            <CardBody className="card-body">
                                <Row>
                                    <Col md="8" xs="12">
                                        <div className="bold text-uppercase blue_dark">Informations livraison</div>
                                        <div className="marg-t-10">
                                            { data.weekdays_repeat.split(',').map(i => days[i]).join(", ") }<br />
                                            { data.location }<br /><br />
                                            { data.details }
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="marg-t-20">
                                    <Col md="6">
                                        <div className="bold text-uppercase blue_dark marg-b-10 d-flex justify-content-between">
                                            V&eacute;hicules
                                            <i className="fa fa-plus pointer blue-hover" onClick={() => { this.setState({ vehicleModalShown: !vehicleModalShown, updateVehicleData: null }); }}></i>
                                        </div>
                                        {
                                            data.vehicles && data.vehicles.map((v, i) => {
                                                return <OperationsRecurrentDetailsVehicle
                                                    key={`v-${i}`} 
                                                    data={v} 
                                                    onUpdate={this.loadData}
                                                    onUpdateClicked={this.onUpdateVehicleRequest} 
                                                />
                                            })
                                        }
                                    </Col>
                                    <Col md="6">
                                        <div className="bold text-uppercase blue_dark marg-b-10 d-flex justify-content-between">
                                            Moyen de paiement 
                                            <i className="fa fa-pencil pointer blue-hover" onClick={() => { this.setState({ updatingPaymentMethod: !updatingPaymentMethod }); }}></i>
                                        </div>

                                        { 
                                            loadingPaymentMethods ? 
                                                <div className="center">
                                                    <i className="icon icon-loading animated spin infinite f-20"> </i>
                                                </div> 
                                                : null
                                        }

                                        {
                                            paymentMethod && !updatingPaymentMethod ?
                                                <TYItem icon={paymentMethod.icon}>
                                                    { paymentMethod.label }
                                                </TYItem>
                                                : null
                                        }

                                        {
                                            updatingPaymentMethod ?
                                                <TYSelect
                                                    className="animated heart-beat"
                                                    items={paymentMethodsForUpdate}
                                                    selected={data.payment_id}
                                                    itemClicked={this.onPaymentMethodChange}
                                                    renderItem={item => { return item.label + " test"; }}
                                                    isSelected={(s, i) => { return s === i.id }}
                                                />
                                                : null
                                        }

                                        <br />
                                        
                                        <div className="bold text-uppercase blue_dark marg-b-10 d-flex justify-content-between">
                                            Contacts
                                            <i className="fa fa-plus pointer blue-hover" onClick={() => { this.setState({ addingContacts: !addingContacts }); }}></i>
                                        </div>
                                        
                                        {
                                            !addingContacts && contacts && contacts.map((v, i) => {
                                                return <OperationsRecurrentDetailsContact 
                                                    key={`c-${i}`} 
                                                    recId={data.id} 
                                                    data={v} 
                                                    onUpdate={this.loadContacts}
                                                />
                                            })
                                        }

                                        {
                                            addingContacts && availableContacts && availableContacts.map((c, i) => {
                                                if(activeContactIds.indexOf(c.id) !== -1)
                                                    return null;
                                                return <TYItem key={`available-contact-${i}`}>
                                                    <div className="d-flex marg-t-10 marg-b-10">
                                                        <div style={{flex: 2}}>
                                                            <span className="bold">{c.contact_name}</span> ({c.contact_type})
                                                            <div className="f-10">
                                                                {c.phone_number}<br />
                                                                {c.email}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-self-center animated flash">
                                                            <button className="btn btn-outline-success btn-xs" onClick={() => { this.addContact(c.id, i); }}>Ajouter</button>
                                                        </div>
                                                    </div>
                                                </TYItem>
                                            })
                                        }

                                        {
                                            addingContacts ?
                                                <div className="d-flex justify-content-center">
                                                    <button className="btn btn-primary btn-sm" onClick={() => { this.setState({addingContacts: false})}}>{'< Retour'}</button>
                                                </div>
                                                : null
                                        }
                                    </Col>
                                </Row>
                            </CardBody>

                        </Card>
                }

            </Col>

            <RecVehicleModal 
                recId={this.state.id}
                shown={vehicleModalShown} 
                onToggle={reload => {
                    this.setState({vehicleModalShown: !vehicleModalShown});
                    if(reload)
                        this.loadData();
                }}
                updateData={updateVehicleData}
                alreadyAdded={activeVehicles}
                onVehicleAdded={() => {
                    this.setState({vehicleModalShown: false});
                    this.loadData();
                }}
            />
        </Row>
    }
}


// WEBPACK FOOTER //
// ./src/components/Operations/Recurrent/index.js